const ADVANTAGES = [
  {
    icon: 'ri-ruler-line',
    title: 'По вашим размерам',
    desc: 'Изготовим ворота точно под проём, с учётом ширины проезда и особенностей участка',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Собственное производство',
    desc: 'Свой цех, контроль качества на каждом этапе — от раскроя металла до финишной покраски',
  },
  {
    icon: 'ri-tools-line',
    title: 'Монтаж под ключ',
    desc: 'Привозим, устанавливаем, настраиваем автоматику — вы принимаете готовые ворота',
  },
];

const WHATSAPP_MSG = encodeURIComponent('Здравствуйте! Хочу рассчитать стоимость ворот.');
const TELEGRAM_MSG = encodeURIComponent('Здравствуйте! Хочу рассчитать стоимость ворот.');

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/b38fecfd-2ee8-4467-a6ea-3b382f69a1d9_compressed_IMG_0316.webp"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 pt-24 pb-16 md:pt-32 md:pb-24">
        <div className="mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center" style={{ maxWidth: '1400px' }}>
          {/* Left column - text */}
          <div className="text-center lg:text-left animate-fade-in-up">
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-4 text-balance">
              Надёжные ворота, которые работают без лишних хлопот
            </h1>
            <p className="text-sm md:text-base text-background-50/80 max-w-lg mx-auto lg:mx-0 mb-3 leading-relaxed">
              Безопасность участка и аккуратный внешний вид въездной зоны. Прочный каркас, надёжная автоматика, установка и&nbsp;настройка под&nbsp;ключ.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row items-center lg:items-start gap-3 mb-10">
              <a
                href="https://max.ru/u/f9LHodD0cOICoHyOC2LT2Vx_42oC8Zdm2VV9Uv5O-6mGvkZgeZzUcJQkER0"
                target="_blank"
                rel="noopener noreferrer"
                className="whitespace-nowrap w-full sm:w-auto bg-accent-600 hover:bg-accent-700 text-background-50 font-semibold text-sm px-7 py-3.5 rounded-md transition-all duration-300 hover:scale-[1.03] active:scale-[0.98] cursor-pointer inline-flex items-center justify-center gap-2.5"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-chat-3-line text-lg"></i>
                </span>
                Рассчитать в MAX
              </a>
              <div className="flex items-center gap-2 flex-wrap justify-center lg:justify-start">
                <a
                  href={`https://wa.me/79174131562?text=${WHATSAPP_MSG}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whitespace-nowrap bg-[#25D366] hover:bg-[#1eb851] text-background-50 font-medium text-sm px-5 py-3 rounded-md transition-all duration-300 hover:scale-[1.03] active:scale-[0.98] cursor-pointer inline-flex items-center gap-2"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-whatsapp-line text-base"></i>
                  </span>
                  WhatsApp
                </a>
                <a
                  href={`https://t.me/share/url?url=&text=${TELEGRAM_MSG}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whitespace-nowrap bg-[#2AABEE] hover:bg-[#2299d6] text-background-50 font-medium text-sm px-5 py-3 rounded-md transition-all duration-300 hover:scale-[1.03] active:scale-[0.98] cursor-pointer inline-flex items-center gap-2"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-telegram-line text-base"></i>
                  </span>
                  Telegram
                </a>
                <a
                  href="tel:+79174131562"
                  className="whitespace-nowrap border-2 border-background-50/30 hover:border-background-50/60 text-background-50 font-medium text-sm px-5 py-3 rounded-md transition-all duration-300 hover:bg-background-50/10 cursor-pointer inline-flex items-center gap-2"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-phone-fill text-base"></i>
                  </span>
                  Позвонить
                </a>
              </div>
            </div>
          </div>

          {/* Right column - large photo (desktop only) */}
          <div className="hidden lg:block animate-fade-in-up" style={{ animationDelay: '0.15s' }}>
            <div className="relative rounded-lg overflow-hidden border-2 border-background-50/20">
              <div className="w-full h-[420px] xl:h-[500px]">
                <img
                  src="https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/93cbeb93-ef14-4cf2-a0ad-fbc7b0b77bdd_compressed_IMG_0480.webp"
                  alt="Готовые ворота на участке"
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Advantages row */}
        <div className="mx-auto mt-14 md:mt-20" style={{ maxWidth: '1400px' }}>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
            {ADVANTAGES.map((item) => (
              <div
                key={item.title}
                className="flex items-start gap-4 bg-background-50/10 backdrop-blur-sm border border-background-50/15 rounded-lg p-4 md:p-5"
              >
                <div className="shrink-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-500/20 text-primary-300">
                  <i className={`${item.icon} text-lg md:text-xl`}></i>
                </div>
                <div>
                  <h3 className="font-heading text-base md:text-lg font-semibold text-background-50 mb-1">{item.title}</h3>
                  <p className="text-xs md:text-sm text-background-50/65 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}